import moment from 'moment';

export const formatDate = (d = moment()) => moment(d).format('YYYY-MM-DD');
export const isToday = (d) => moment(d).isSame(moment(), 'day');
